import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const cookieBeacon: Example = {
  id: "cookie-beacon",
  title: "Cookie exfil via image beacon",
  group: "technique",
  environment: "browser",
  mode: "script",
  summary: "Base64-encodes document.cookie into an image URL",
  explainer:
    "No fetch or XHR in sight: an `Image` whose `src` carries `btoa(document.cookie)` is enough. The Timeline shows the STORAGE read of `document.cookie`, then a NET resource load to px.example whose URL contains the encoded cookies, badged `canary`: the page's `session_id` and `_ga` cookies hold this run's honeytokens, and the engine finds them inside the URL-encoded base64. The Report turns that into a critical exfiltration finding for the session cookie (and a suspicious one for the analytics id).",
  code,
  expect: golden as Example["expect"],
};
